<template>
    <div>
      <el-form style="margin-right: 20px" :model="sipForm" :rules="rules" ref="sipForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="sip电话" prop="sipid">
          <el-select v-fixZoom style="width: 100%" v-model="sipForm.sipid" placeholder="请选择">
            <el-option
              v-for="item in sipOpt"
              :key="item.value"
              :label="item.sip_username"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button @click="closeEdit()">取 消</el-button>
        <el-button type="primary" @click="submitBindSip('sipForm')">确 定</el-button>
      </div>
    </div>
</template>

<script>
import {oemuserbindsip} from '../../../api/sipPhone'

export default {
  name: 'bindSip',
  model: {
    prop: 'sipShow',
    event: 'change'
  },
  props: {
    sips: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      sipOpt: [],
      row: '',
      sipForm: {
        sipid: '',
        syspersonid: ''
      },
      rules: {
        sipid: [
          { required: true, message: '请选择sip电话', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.sipOpt = this.sips.sips
    this.row = this.sips.row
    this.sipForm.syspersonid = this.row.id
    // console.log(1111, this.sipOpt)
  },
  methods: {
    submitBindSip (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          oemuserbindsip(this.sipForm).then(res => {
            this.$notify({
              title: '成功',
              message: '成功绑定sip电话',
              type: 'success',
              duration: 2000
            })
            this.golobleObject.updateTableUser()
            this.$emit('change', false)
          }).catch(() => {
            this.$notify.error({
              title: '失败',
              message: '绑定sip电话失败'
            })
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeEdit () {
      this.$emit('change', false)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/bindSip.vue